var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rentSuccess"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"btn",on:{"click":_vm.toIndex}},[_vm._v("返回首页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('img',{attrs:{"src":require("./img/successIcon.png")}}),_c('div',{staticClass:"txt"},[_vm._v("您的申请已经提交成功～")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-img"},[_c('img',{attrs:{"src":require("./img/successBg.png"),"alt":""}})])
}]

export { render, staticRenderFns }